import { render } from "./ListeMandature.vue?vue&type=template&id=5fb0fab4&ts=true"
import script from "./ListeMandature.vue?vue&type=script&lang=ts"
export * from "./ListeMandature.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__